<template>
  <b-sidebar :id="`product-comment-${commentable_id}`" bg-variant="transparent" width="400px"
             class="text-dark" no-header backdrop>

    <b-row id="scroll" class="comment d-flex flex-row justify-content-center">
      <b-col cols="12" class="d-flex flex-column align-items-center">
        <b-row class="d-flex flex-row justify-content-start align-items-start p-3 w-100">

          <b-button variant="transparent" v-b-toggle="'product-comment-'+commentable_id">
            <b-icon variant="transparent" class="text-dark" icon="x"/>
          </b-button>
        </b-row>
        <b-row class="d-flex flex-row justify-content-center align-items-center p-3 w-100">
          <h5 class="comment-title">{{ commentable_name }}</h5>
        </b-row>

        <b-row class="w-100" v-for="comment in comments" :key="comment.id">

          <b-col lg="12" class="d-flex flex-column align-items-center">

            <b-row class="d-flex flex-row align-items-start w-100">
              <h4 class="secondary-text">{{ comment.user.name + ' ' + comment.user.last_name }}</h4>
              <b-col cols="4" class="d-flex flex-row justify-content-center">
                <div class="justify-center" v-for="i in 5" :key="i">
                  <b-icon icon="star-fill" font-scale=".75" variant="warning" v-if="i<=comment.rate"/>
                  <b-icon icon="star" font-scale=".75" variant="warning" v-else/>
                </div>
              </b-col>
            </b-row>

            <b-row class="d-flex flex-row align-items-center">
              <b-container>
                <b-row>
                  <b-col lg="12">
                    <div class="h4 wrap-text text-2" v-html="comment.body"/>
                  </b-col>
                </b-row>
              </b-container>
            </b-row>
            <b-row class="d-flex flex-row justify-content-center w-100">
              <hr>
            </b-row>

          </b-col>

        </b-row>

        <m-pagination-400 class="mb-5" v-if="comments.length!=0" :meta="meta" :onChangePage="changeCommentPage"/>

      </b-col>

      <b-row class="w-100 d-flex flex-row justify-content-center" v-if="comments.length===0">
        <span class="text-dark">هیچ نظری ثبت نشده است</span>
      </b-row>


      <b-row class="d-flex flex-row justify-content-center w-100">
        <b-col class="d-flex flex-column align-items-center">

          <m-comment-create-modal-1 :commentable_id="commentable_id" :commentable_type="commentable_type" />

        </b-col>
      </b-row>

    </b-row>


  </b-sidebar>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ShowCommentsOnSide",
  props: ['comments', 'commentable_id', 'commentable_name', 'commentable_type'],
  computed: {
    ...mapGetters({
      meta: 'Comment/getMeta',
    })
  },
  methods: {
    changeCommentPage(page) {
      let form = {id: this.commentable_id, comment_type: this.commentable_type}
      this.$store.dispatch("Comment/getClientComments", {form: form, page: page})
    },
  },
  mounted() {
    const boxes = document.querySelectorAll(`#product-comment-${this.commentable_id} .b-sidebar-body`);
    boxes.forEach(box => {
      box.style.padding = '20px 0 20px 0';
      box.style.display = 'flex';
      box.style.flexDirection = 'column';
      box.style.alignItems = 'center';
      box.style.height = '100%';
      box.style.borderRadius = '0 40px 40px 0';
      box.style.margin = '20px 0 20px 0';
      box.style.backgroundColor = 'white';
    });
  }
}
</script>


<style scoped>

.comment {
  border-radius: 30px;
  background-color: #fdfdfd;
  width: 100%;
  height: max-content;

}

hr {
  border: 1px solid grey;
  width: 80%;
}

</style>